import { Entidade } from './../entidade/entidade';
import { Resource } from '../../../common/resource.model';
import { TipoLogradouro } from '../../enderecamento/tipo-logradouro/tipo-logradouro';
import { Municipio } from '../../enderecamento/municipio/municipio';

export class UnidadeGestora extends Resource {
    nome: string;
    entidade: Entidade;
    tipoLogradouro:TipoLogradouro;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro : string;
    cep: string;
    municipio: Municipio;
    telefone: string;
    site: string;
    email: string;
    ativo: boolean;
}
